import { useEffect, useState } from 'preact/hooks';
import { PaymentMethodResult } from '../iap.types';
import { PopupOpenWebPayViewStyle } from './PopupOpenWebPayViewStyle';
import { ProductId } from 'src/replicant/iap';
import { PaymentView } from './PaymentView';
import { assertNever } from 'src/replicant/utils';
import { InfoView } from './InfoView';
import { WebPaymentMethodAnalytics } from '../analytics/analytics.types';

/**
 * Render a view that allows the user to select a payment method and enter payment details.
 * @param opts - The options for the view.
 * @returns
 */
export function PopupOpenWebPayView(opts: {
  productId: ProductId;
  close: (result: PaymentMethodResult) => void;
  onMethodSelected: (
    data: WebPaymentMethodAnalytics,
    isCancel: boolean,
  ) => void;
  onPurchaseStart: (data: WebPaymentMethodAnalytics) => void;
  onAgeConfirm: (
    data: WebPaymentMethodAnalytics & { accepted: boolean },
  ) => void;
  onCloseStart: (data: WebPaymentMethodAnalytics) => void;
  onCloseCancel: (data: WebPaymentMethodAnalytics) => void;
}) {
  // State.
  const [baseClassName, setBaseClassName] = useState<string>('popup');
  const [page, setPage] = useState<'pay' | 'info'>('pay');

  // On mount.
  useEffect(() => {
    // Change class name based on orientation.
    const handleResize = () => {
      const isPortrait = window.innerWidth < window.innerHeight;
      setBaseClassName(isPortrait ? 'popupMobile' : 'popup');
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    // On unmount.
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Render content based on page.
  let content;
  switch (page) {
    case 'pay':
      content = (
        <PaymentView
          productId={opts.productId}
          close={opts.close}
          setPage={setPage}
          onMethodSelected={opts.onMethodSelected}
          onPurchaseStart={opts.onPurchaseStart}
          onAgeConfirm={opts.onAgeConfirm}
          onCloseStart={opts.onCloseStart}
          onCloseCancel={opts.onCloseCancel}
        />
      );
      break;

    case 'info':
      content = <InfoView setPage={setPage} />;
      break;

    default:
      assertNever(page);
  }

  return (
    <>
      <PopupOpenWebPayViewStyle />
      <div class="view" id="paymentRoot">
        <div class={baseClassName} id="paymentPopup">
          {content}
        </div>
      </div>
    </>
  );
}
